import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { User, Mail, Calendar, LogOut } from 'lucide-react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import PasskeyManager from '../../components/PasskeyManager';

export default function WorkerProfilo() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="space-y-4" data-testid="worker-profilo">
      <h1 className="text-xl font-bold text-slate-900">Il Mio Profilo</h1>

      <Card className="border-slate-200">
        <CardContent className="p-6">
          <div className="flex flex-col items-center text-center mb-6">
            <div className="h-20 w-20 rounded-full bg-slate-200 flex items-center justify-center mb-4">
              <span className="text-2xl font-bold text-slate-600">{user?.name?.charAt(0)}</span>
            </div>
            <h2 className="text-xl font-bold text-slate-900">{user?.name}</h2>
            <p className="text-slate-500">Operaio</p>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Mail className="h-5 w-5 text-slate-500" />
              <div>
                <p className="text-xs text-slate-500">Email</p>
                <p className="font-medium text-slate-900">{user?.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Calendar className="h-5 w-5 text-slate-500" />
              <div>
                <p className="text-xs text-slate-500">Registrato dal</p>
                <p className="font-medium text-slate-900">
                  {user?.created_at ? format(new Date(user.created_at), 'dd MMMM yyyy', { locale: it }) : 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <PasskeyManager compact />

      <Button 
        variant="outline" 
        className="w-full text-red-600 border-red-200 hover:bg-red-50"
        onClick={handleLogout}
        data-testid="logout-btn"
      >
        <LogOut className="h-4 w-4 mr-2" />
        Esci dall'account
      </Button>
    </div>
  );
}
